import { useMemo, useRef, MouseEvent, useContext } from "react";
import { NavItems } from "../../../types/User/IUserProfile";
import cx from "classnames";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";
import { updateIframeSrc } from "../../../slices/RevelationSlice";
import { INavTransform } from "../../../types/INavTransform";
import { AddTextAndItemsAttrToNavItems } from "../../../utils/utils";
import useEventListener from "@use-it/event-listener";
import { setContextMenuOpen } from "../NavSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { TicketLocationState } from "../../Ticket/TicketRoute";
import { nanoid } from "nanoid";
import { RevUserContext, RevUserContextType } from "../../../context/UserContext";
// Below is for testing purposes
// import { navStyle } from "../NavLogo";

export const NAV_BUTTON_CLASS_NAME = "nav-button";

export interface INavButtonProps extends NavItems {
  baseUrl: string;
  disabled?: boolean;
  buttonColor?: string;
  navStyle: number;
  onContextMenu?: (e: MouseEvent) => void;
  isMoreItems?: boolean;
}

const NavButton = ({ props }: { props: INavButtonProps }) => {
  let location = useLocation();
  let navigate = useNavigate();
  const { setBackgroundLocation } = useContext<RevUserContextType>(RevUserContext)
  const contextMenuOpen = useReduxSelector(
    (state) => state.nav.contextMenuOpen
  );
  const anchor = useRef<HTMLDivElement | null>(null);
  /** handles how context menu items are rendered */
  const dispatch = useReduxDispatch();
  /** updates iframe. I should move this to utils so that all apps can use this. */
  function handleOnClick(item: INavButtonProps) {
    if (item.Url) {
      if (item.Url.indexOf("./") === 0) {
        //internal URL, not IFrame
        const ticketState = {
          background: location,
        } as unknown as TicketLocationState;

        //trim leading . from URL if it starts with a .
        let trimmedStr = item.Url.startsWith('.') ? item.Url.substring(1) : item.Url;
        console.warn('navigate', trimmedStr, item.Url, ticketState)

        // Use global state so we can navigate inside the log a ticket modal
        setBackgroundLocation(location as unknown as Location);
        navigate(trimmedStr);
        //navigate(item.Url);
      } else {
        navigate("/");
        //console.log('item.Url', item.Url)
        dispatch(
          updateIframeSrc(
            `${item.Url}${item.Url.indexOf("?") > -1 ? "&" : "?"}d=${nanoid()}`
          )
        );
      }
    }
    dispatch(setContextMenuOpen(""));
  }
  /** handles right-click */
  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(setContextMenuOpen(props.Text));
    props.onContextMenu?.(e);
  };
  /** closes the menu upon the user clicking anywhere */
  useEventListener("click", () => {
    if (document.activeElement !== anchor.current && contextMenuOpen !== "")
      dispatch(setContextMenuOpen(""));
  });
  /** Apply styles depending on navStyle. Comment out navStyle when testing.*/
  const {
    navStyle,
    disabled,
    buttonColor,
    Text,
    //Url,
    Image_Url,
    Tooltip,
  } = props;
  const { navTextSize, buttonStyle, symbolSize } = ApplyCustomStyles(navStyle);
  /** Change div > button height and width depending navStyle */
  let divHeight: string;
  let buttonWidth: string = "w-[70px]";
  // @ts-ignore
  if (navStyle === 0 || navStyle === 1) {
    divHeight = "h-[70px]";
  } else if (navStyle === 2) {
    divHeight = "h-11";
    buttonWidth = "w-[44px]";
  } else {
    divHeight = "h-11";
  }
  return (
    <div
      onContextMenu={handleContextMenu}
      ref={anchor}
      // title={`${Text}: ${Tooltip}`}
      className={cx("relative", NAV_BUTTON_CLASS_NAME)}
      title={`${Text}`}
    >
      {props.Nav_Items?.length > 0 && props.Name !== 'more-items' ? (
        <div className="context-icon">
          <img
            src={"./images/context-menu-indicator.png"}
            alt="context menu indicator"
          />
        </div>
      ) : null}
      <div className={cx({ "opacity-75": disabled }, divHeight)}>
        <div
          onClick={() => handleOnClick(props)}
          className={cx(
            "md:px-1 shadow-lg grid place-content-center h-full",
            buttonStyle,
            buttonWidth
          )}
          style={{ backgroundColor: `${buttonColor}` }}
        >
          {/* @ts-ignore */}
          {navStyle === 0 || navStyle === 1 || navStyle === 2 ? (
            <div className={cx("grid place-content-center nav-icon", props.isMoreItems ? "mt-2" : "")}>
              <img
                src={
                  Image_Url?.indexOf("https://") > -1
                    ? Image_Url
                    : process.env.PUBLIC_URL + Image_Url
                }
                alt={props.Text}
                width={symbolSize}
              />
            </div>
          ) : null}
          {/* @ts-ignore */}
          {navStyle === 0 || navStyle === 3 ? (
            <h1
              className={cx(
                "text-white truncate max-w-full inline-block whitespace-normal",
                navTextSize,
                props.isMoreItems ? "mt-1" : ""
              )}
              title={Tooltip}
            >
              {Text}
            </h1>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default NavButton;

function ApplyCustomStyles(navStyle: number) {
  let navTextSize = "text-xs";
  let buttonStyle = "p-1";
  let symbolSize = 30;

  switch (navStyle) {
    case 1:
      symbolSize = 40;
      break;
    case 2:
      buttonStyle = "";
      symbolSize = 25;
      break;
    default:
      break;
  }
  return { navTextSize, buttonStyle, symbolSize };
}

function handleItemRender(
  props: INavTransform,
  handleClickFunc: (arg: any) => void
) {
  return (
    <button
      key={props.itemId}
      onClick={handleClickFunc}
      style={{
        color: "black",
        fontSize: "small",
      }}
    >
      {props.item.Text}
    </button>
  );
}
